import { schema } from 'normalizr';
const documentResourceSectionSchema = new schema.Entity('resourceSections', {}, {
    idAttribute: 'resourceSectionId'
});
const documentSectionSchema = new schema.Entity('sections', {
    meta: {
        resourceSections: [
            documentResourceSectionSchema
        ]
    }
}, {
    idAttribute: 'documentSectionId'
});
export const documentTemplateSchema = new schema.Entity('template', {
    templateContent: {
        sections: [
            documentSectionSchema
        ]
    }
}, {
    idAttribute: 'templateId'
});
